import type { NextPage } from 'next'
import { Login } from '@/client/modules/Login'
import { LoginProps } from '@/client/modules/Login/types'
import { getCMSContent } from '@/client/utils'

const LoginPage: NextPage<LoginProps> = (data) => <Login {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'LOGIN')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default LoginPage
